import { Timeslot } from "../redux/types";

export const getTimeslotStatus = (timeslot: Timeslot) => {
  // const { booked, blocked } = timeslot;
  const booked = timeslot?.booked;
  const blocked = timeslot?.blocked;
  return booked ? "رزرو شده" : blocked ? "غیرفعال" : "قابل رزرو";
};
